import React from 'react'
import '../confirm-remove/index'

const TooManyObjects = (props) => {
  const { remove, cancel, type, upgrade } = props
  const handleParentClick = (e) => {
    e.stopPropagation();
  }

  return (
    <div className='confirm-removal-container-two' onClick={cancel}>
      <div className='alert-box-container'
        onClick={(e) => handleParentClick}
      >
        <div className='alert-center'>
          <p style={{ fontSize: '18px', margin: '20px', fontWeight: 'bold', textAlign: 'center', lineHeight: 1.5 }}>{`You have exceeded the maximum limit for the Basic account.`}</p>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
            <button
              onClick={cancel}
              style={{ margin: '0', width: '45%' }}>CANCEL</button>
            <button
              onClick={upgrade}
              style={{ margin: '0', backgroundColor: '#ff6800', width: '45%' }}>Upgrade</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TooManyObjects